import React, { memo, useEffect, useRef } from 'react';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

import { COLORS } from '@bcm/constants';
import commonStyles from '../styles/common';
import GradientBackground from '../GradientBackground';

export const CARD_TYPES = {
	wide: 'wide',
	narrow: 'narrow',
};

const Card = ({
	isFullscreen,
	cardType,
	children,
	hideGradient,
	scrollToEnd,
	backgroundColor,
}) => {
	const ref = useRef();

	useEffect(() => {
		if(scrollToEnd) ref.current.scrollToEnd();
	}, [scrollToEnd]);


	const layout = useWindowDimensions();
	const styles = StyleSheet.create({
		cardContainer: {
			justifyContent: isFullscreen ? undefined : 'center',
			alignItems: isFullscreen ? undefined : 'center',
			flexGrow: 1,
		},
		card: {
			flex: isFullscreen ? 1 : undefined,
			width: (cardType === CARD_TYPES.narrow && !isFullscreen) ? 0.4 * layout.width
				: (cardType === CARD_TYPES.narrow && isFullscreen) ? 1.0 * layout.width
					: (cardType === CARD_TYPES.wide && !isFullscreen) ? 0.7 * layout.width
						: '100%',
			backgroundColor: backgroundColor ? backgroundColor : COLORS.light,
			...(!isFullscreen) ? commonStyles.shadow : {},
		},
	});

	return (
		<KeyboardAwareScrollView
			ref={ref}
			contentContainerStyle={styles.cardContainer}
		>
			{!hideGradient && <GradientBackground
				style={styles.card}
				color={COLORS.light}
			>
				{children}
			</GradientBackground>}
			{hideGradient && <View
				style={styles.card}
			>
				{children}
			</View>}
		</KeyboardAwareScrollView>
	);
};

export default memo(Card);